import "./Contact.css"
import github_logo from '../../assets/github-homepagelogo.png'
import linkedin_logo from '../../assets/linkedin-homepagelogo.png'

function Contact(){
    return(
        <div className="contact-container">
            <p>FIND ME ON</p>
            <p id="contact-subheading">Feel free to connect with me</p>
            <a href="https://github.com/anishkumar28">
              <img src={github_logo}  className="github_logo" alt="github_logo"/>
            </a>
            <a href="https://www.linkedin.com/in/anishkumar28/">
              <img src={linkedin_logo} onClick='' className='linkedin_logo' alt="linkedin_logo"/>
            </a>
        </div>
    );
}

export default Contact;